import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function groupAuditScopesReducer(state = initialState.groupAuditScopes, action) {
	switch (action.type) {
		case types.GET_GROUP_AUDIT_SCOPES: {
			return action.response.groupTaskComponents;
		}
		case types.CLEAN_GROUP_AUDIT_SCOPES: {
			return initialState.groupAuditScopes;
		}
		default:
			return state;
	}
}
